import { AssetSwapSuccessView, type AssetSwapSuccessViewProps } from './AssetSwapSuccessView'

export type PositionAssetSwapSuccessViewProps = Omit<AssetSwapSuccessViewProps, 'isWalletDestination'>

export function PositionAssetSwapSuccessView(props: PositionAssetSwapSuccessViewProps) {
  return <AssetSwapSuccessView {...props} proceedText={props.proceedText ?? 'Done'} />
}
